/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Option } from '@/utils/types';
import Image from 'next/image';
import React from 'react'

type UserCardProps = {
  user: Option;
  showEmail?: boolean;
  truncate?:boolean;
}

const UserCard = ({ user, showEmail = false, truncate = false }: UserCardProps) => {  
  return (
    <div 
    className="flex items-center gap-2">
      {/* <img
        src={user?.avatar || zipLogo}
        className="w-11 h-11 rounded-full object-cover"
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = zipLogo;
        }}
      /> */}
      <Avatar className="h-8 w-8 rounded-full">
                    <AvatarImage
                      src={user?.avatar}
                      alt={user?.name || user?.label}
                    />
                    <AvatarFallback className="rounded-full">
                      <Image
                        src="/icons/profile-default.svg"
                        className="rounded-full w-[30px] h-[30px] object-cover"
                        height={30}
                        width={30}
                        alt="profile"
                        onError={e => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = '/icons/profile-default.svg';
                        }}
                      />
                    </AvatarFallback>
                  </Avatar>
      <div className={`flex flex-col gap-1 ${truncate ? 'max-w-[120px]' : ''}`}>
        <h4 className={`text-sm font-medium ${truncate ? 'truncate' : ''}`} title={user?.name || user?.label}>
          {user?.name || user?.label}
        </h4>
        {showEmail && (
          <p className={`text-xs font-normal text-[505056] ${truncate ? 'truncate' : ''}`} title={user?.value}>
            {user?.value}
          </p>
        )}
      </div>
    </div>
  )};

export default UserCard